import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import LegacyView from '../../../../components/legacyView/LegacyView';

const TrackedFlight: FunctionComponent = () => {
    const { rideId }: {rideId: string} = useParams();

    return (
        <LegacyView
            path={`/rides/${rideId}/change/flight`}
            title={`Ride ${rideId}: Change flight`}
        />
    );
};

export default TrackedFlight;
